export { default } from './LoanInfoHeader';
